export default __webpack_public_path__ + "static/media/ic_crv_40.30bf7cd5.svg";